export const OPEN_ID_PROVIDERS = {
  vipps: 'oidc.vipps',
  google: 'google.com',
  apple: 'apple.com'
};

export const OPEN_ID_LOGIN_HANDLERS = {
  [OPEN_ID_PROVIDERS.vipps]: window.FIREBASE.signInWithVipps,
  [OPEN_ID_PROVIDERS.google]: window.FIREBASE.signInWithGoogle,
  [OPEN_ID_PROVIDERS.apple]: window.FIREBASE.signInWithApple
};

export const OPEN_ID_REAUTHENTICATE_HANDLERS = {
  [OPEN_ID_PROVIDERS.vipps]: () => window.FIREBASE.signInWithVipps({ reauthenticate: true }),
  [OPEN_ID_PROVIDERS.google]: () => window.FIREBASE.signInWithGoogle({ reauthenticate: true }),
  [OPEN_ID_PROVIDERS.apple]: () => window.FIREBASE.signInWithApple({ reauthenticate: true })
};

export const isNativeProvider = provider =>
  [OPEN_ID_PROVIDERS.google, OPEN_ID_PROVIDERS.apple, OPEN_ID_PROVIDERS.vipps].includes(provider);

export const URL_PARAMS = {
  loginWith: 'loginWith',
  verifyLoginEmail: 'verifyLoginEmail',
  verifyLoginIdtoken: 'verifyLoginIdtoken',
  referralCode: 'referralCode',
  cardPartnershipCode: 'cardPartnershipCode',
  loginError: 'loginError'
};
